import { Box, type SxProps, Typography } from "@mui/material";

export function StatCard({
  stat,
  title,
  desc,
  sx,
}: {
  stat: string | number;
  title: string;
  desc?: string;
  sx: SxProps;
}) {
  return (
    <Box
      sx={[
        {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          bgcolor: "background.card",
          p: 2,
          containerType: "inline-size",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Typography
        variant="h4"
        sx={{
          opacity: 0.6,
          textAlign: "center",
          fontSize: {
            "@": 2 * 8,
            "@300": 2.5 * 8,
          },
        }}
      >
        {title}
      </Typography>
      <Typography
        variant="h2"
        sx={{
          textAlign: "center",
          fontSize: {
            "@": 3.5 * 8,
            "@300": 4.5 * 8,
          },
        }}
      >
        {stat}
      </Typography>
      {desc && (
        <Typography
          variant="h5"
          sx={{
            opacity: 0.6,
            textAlign: "center",
            fontSize: {
              "@": 1.5 * 8,
              "@300": 2 * 8,
            },
          }}
        >
          {desc}
        </Typography>
      )}
    </Box>
  );
}
